import * as Messenger from "../messenger";
export const sendAuth = (auth) => Messenger.sendMessageToSW({
    type: "SET_AUTH",
    auth,
});
